import React from 'react';
import DocumentPdfViewer from './DocumentPdfViewer';

export default function DocCanvas({
  s3Key,
  mimetype,
  filename,
  activeBbox,
  onRegionClick,
}) {
  return (
    <DocumentPdfViewer
      s3Key={s3Key}
      mimetype={mimetype}
      filename={filename}
      activeBbox={activeBbox}
      onRegionClick={onRegionClick}
    />
  );
}
